import FamiliesArchive from "./archive.es6";
import FamiliesSingle from "./single.es6";

export default class Main {
    constructor() {
        this.familiesArchive = new FamiliesArchive();
        this.familiesSingle = new FamiliesSingle();
    }

    init() {}
}
